import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AskPodPopupInterface, AskPodPopupModel } from './askpod-popup.model';

@Component({
    selector: 'app-askpod-popup',
    templateUrl: './askpod-popup.component.html',
})
export class AskPodPopupComponent {
    data: AskPodPopupModel;

    constructor(@Inject(MAT_DIALOG_DATA) popupData: AskPodPopupInterface) {
        this.data = new AskPodPopupModel(popupData || ({} as AskPodPopupInterface));
    }
}

export function openAskPodDialog(
    dialog: MatDialog,
    popupData?: AskPodPopupInterface
): MatDialogRef<AskPodPopupComponent> {
    const config = new MatDialogConfig();

    config.autoFocus = false;
    config.disableClose = false;
    config.maxWidth = '31.25rem';
    config.width = '90vw';
    config.panelClass = 'askpod-popup-dialog';
    config.data = { ...popupData };

    return dialog.open(AskPodPopupComponent, config);
}
